<template>
    <label 
            v-if="label"
            :for="id" 
            class="label-form"
            :class="{'text-red-700 dark:text-red-500': hasError}">
            <span>{{ label }}</span>
            <em v-if="isRequired" class="not-italic text-red-500">*</em>
    </label>
    <input
        :id="id"
        :value="modelValue" 
        class="input-form outline-none border px-3 py-2 rounded-lg w-full text-xs font-light text-gray-600" 
        @input="$emit('update:modelValue', $event.target.value)"
        v-bind="$attrs"
        :class="{'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 rounded-lg focus:ring-red-500 focus:border-red-500 block w-full p-2.5 dark:bg-red-100 dark:border-red-400': hasError}" />
        
        <p 
            class="mt-2 text-xs text-red-600 dark:text-red-500"
            v-for="error in validate?.$errors" :key="error.$uid">
            {{ error.$message }}
        </p>    
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue';

defineEmits(['update:modelValue']);

const props = defineProps({
    id:{
        required: true,
        type: String
    },
    label: {
        required: false,
        type: String
    },
    modelValue: {
        type: String,
        default: ""
    },
    validate: {
        type: Object,
        default: () => {}
    }
});

const hasError = computed(() => props.validate?.$errors?.length > 0);
const isRequired = computed(() => !!props.validate?.required);
</script>